function cov_hai8ntsct() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/components/views/App.tsx";
    var hash = "1edf3c733d8243b1bc416a052537ae777caab3ad";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/components/views/App.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 52,
                    column: 30
                },
                end: {
                    line: 52,
                    column: 72
                }
            },
            "1": {
                start: {
                    line: 52,
                    column: 47
                },
                end: {
                    line: 52,
                    column: 71
                }
            },
            "2": {
                start: {
                    line: 53,
                    column: 26
                },
                end: {
                    line: 53,
                    column: 64
                }
            },
            "3": {
                start: {
                    line: 53,
                    column: 43
                },
                end: {
                    line: 53,
                    column: 63
                }
            },
            "4": {
                start: {
                    line: 54,
                    column: 30
                },
                end: {
                    line: 54,
                    column: 72
                }
            },
            "5": {
                start: {
                    line: 54,
                    column: 47
                },
                end: {
                    line: 54,
                    column: 71
                }
            },
            "6": {
                start: {
                    line: 55,
                    column: 24
                },
                end: {
                    line: 55,
                    column: 60
                }
            },
            "7": {
                start: {
                    line: 55,
                    column: 41
                },
                end: {
                    line: 55,
                    column: 59
                }
            },
            "8": {
                start: {
                    line: 56,
                    column: 27
                },
                end: {
                    line: 56,
                    column: 66
                }
            },
            "9": {
                start: {
                    line: 56,
                    column: 44
                },
                end: {
                    line: 56,
                    column: 65
                }
            },
            "10": {
                start: {
                    line: 57,
                    column: 28
                },
                end: {
                    line: 57,
                    column: 68
                }
            },
            "11": {
                start: {
                    line: 57,
                    column: 45
                },
                end: {
                    line: 57,
                    column: 67
                }
            },
            "12": {
                start: {
                    line: 58,
                    column: 21
                },
                end: {
                    line: 58,
                    column: 54
                }
            },
            "13": {
                start: {
                    line: 58,
                    column: 38
                },
                end: {
                    line: 58,
                    column: 53
                }
            },
            "14": {
                start: {
                    line: 59,
                    column: 36
                },
                end: {
                    line: 61,
                    column: 1
                }
            },
            "15": {
                start: {
                    line: 60,
                    column: 7
                },
                end: {
                    line: 60,
                    column: 37
                }
            },
            "16": {
                start: {
                    line: 62,
                    column: 22
                },
                end: {
                    line: 62,
                    column: 56
                }
            },
            "17": {
                start: {
                    line: 62,
                    column: 39
                },
                end: {
                    line: 62,
                    column: 55
                }
            },
            "18": {
                start: {
                    line: 63,
                    column: 26
                },
                end: {
                    line: 63,
                    column: 64
                }
            },
            "19": {
                start: {
                    line: 63,
                    column: 43
                },
                end: {
                    line: 63,
                    column: 63
                }
            },
            "20": {
                start: {
                    line: 64,
                    column: 34
                },
                end: {
                    line: 66,
                    column: 1
                }
            },
            "21": {
                start: {
                    line: 65,
                    column: 7
                },
                end: {
                    line: 65,
                    column: 35
                }
            },
            "22": {
                start: {
                    line: 69,
                    column: 20
                },
                end: {
                    line: 69,
                    column: 49
                }
            },
            "23": {
                start: {
                    line: 70,
                    column: 19
                },
                end: {
                    line: 70,
                    column: 39
                }
            },
            "24": {
                start: {
                    line: 71,
                    column: 25
                },
                end: {
                    line: 71,
                    column: 53
                }
            },
            "25": {
                start: {
                    line: 73,
                    column: 22
                },
                end: {
                    line: 353,
                    column: 1
                }
            },
            "26": {
                start: {
                    line: 75,
                    column: 18
                },
                end: {
                    line: 75,
                    column: 31
                }
            },
            "27": {
                start: {
                    line: 76,
                    column: 18
                },
                end: {
                    line: 76,
                    column: 31
                }
            },
            "28": {
                start: {
                    line: 77,
                    column: 18
                },
                end: {
                    line: 77,
                    column: 31
                }
            },
            "29": {
                start: {
                    line: 78,
                    column: 39
                },
                end: {
                    line: 78,
                    column: 56
                }
            },
            "30": {
                start: {
                    line: 81,
                    column: 2
                },
                end: {
                    line: 81,
                    column: 37
                }
            },
            "31": {
                start: {
                    line: 83,
                    column: 2
                },
                end: {
                    line: 83,
                    column: 35
                }
            },
            "32": {
                start: {
                    line: 88,
                    column: 5
                },
                end: {
                    line: 88,
                    column: 54
                }
            },
            "33": {
                start: {
                    line: 90,
                    column: 2
                },
                end: {
                    line: 90,
                    column: 53
                }
            },
            "34": {
                start: {
                    line: 91,
                    column: 26
                },
                end: {
                    line: 91,
                    column: 44
                }
            },
            "35": {
                start: {
                    line: 92,
                    column: 22
                },
                end: {
                    line: 94,
                    column: 39
                }
            },
            "36": {
                start: {
                    line: 96,
                    column: 2
                },
                end: {
                    line: 96,
                    column: 62
                }
            },
            "37": {
                start: {
                    line: 98,
                    column: 32
                },
                end: {
                    line: 98,
                    column: 76
                }
            },
            "38": {
                start: {
                    line: 99,
                    column: 36
                },
                end: {
                    line: 102,
                    column: 2
                }
            },
            "39": {
                start: {
                    line: 103,
                    column: 34
                },
                end: {
                    line: 106,
                    column: 2
                }
            },
            "40": {
                start: {
                    line: 107,
                    column: 45
                },
                end: {
                    line: 110,
                    column: 2
                }
            },
            "41": {
                start: {
                    line: 111,
                    column: 38
                },
                end: {
                    line: 114,
                    column: 2
                }
            },
            "42": {
                start: {
                    line: 115,
                    column: 47
                },
                end: {
                    line: 118,
                    column: 2
                }
            },
            "43": {
                start: {
                    line: 119,
                    column: 37
                },
                end: {
                    line: 122,
                    column: 2
                }
            },
            "44": {
                start: {
                    line: 123,
                    column: 34
                },
                end: {
                    line: 126,
                    column: 2
                }
            },
            "45": {
                start: {
                    line: 127,
                    column: 27
                },
                end: {
                    line: 127,
                    column: 66
                }
            },
            "46": {
                start: {
                    line: 128,
                    column: 33
                },
                end: {
                    line: 131,
                    column: 2
                }
            },
            "47": {
                start: {
                    line: 132,
                    column: 30
                },
                end: {
                    line: 132,
                    column: 72
                }
            },
            "48": {
                start: {
                    line: 134,
                    column: 22
                },
                end: {
                    line: 134,
                    column: 30
                }
            },
            "49": {
                start: {
                    line: 135,
                    column: 20
                },
                end: {
                    line: 137,
                    column: 3
                }
            },
            "50": {
                start: {
                    line: 138,
                    column: 39
                },
                end: {
                    line: 138,
                    column: 73
                }
            },
            "51": {
                start: {
                    line: 139,
                    column: 30
                },
                end: {
                    line: 139,
                    column: 55
                }
            },
            "52": {
                start: {
                    line: 140,
                    column: 50
                },
                end: {
                    line: 142,
                    column: 2
                }
            },
            "53": {
                start: {
                    line: 143,
                    column: 35
                },
                end: {
                    line: 143,
                    column: 60
                }
            },
            "54": {
                start: {
                    line: 145,
                    column: 17
                },
                end: {
                    line: 148,
                    column: 3
                }
            },
            "55": {
                start: {
                    line: 150,
                    column: 16
                },
                end: {
                    line: 161,
                    column: 2
                }
            },
            "56": {
                start: {
                    line: 151,
                    column: 2
                },
                end: {
                    line: 160,
                    column: 3
                }
            },
            "57": {
                start: {
                    line: 152,
                    column: 3
                },
                end: {
                    line: 152,
                    column: 54
                }
            },
            "58": {
                start: {
                    line: 154,
                    column: 3
                },
                end: {
                    line: 154,
                    column: 28
                }
            },
            "59": {
                start: {
                    line: 155,
                    column: 3
                },
                end: {
                    line: 155,
                    column: 30
                }
            },
            "60": {
                start: {
                    line: 157,
                    column: 3
                },
                end: {
                    line: 159,
                    column: 6
                }
            },
            "61": {
                start: {
                    line: 163,
                    column: 1
                },
                end: {
                    line: 169,
                    column: 8
                }
            },
            "62": {
                start: {
                    line: 164,
                    column: 2
                },
                end: {
                    line: 166,
                    column: 3
                }
            },
            "63": {
                start: {
                    line: 165,
                    column: 3
                },
                end: {
                    line: 165,
                    column: 23
                }
            },
            "64": {
                start: {
                    line: 168,
                    column: 2
                },
                end: {
                    line: 168,
                    column: 42
                }
            },
            "65": {
                start: {
                    line: 171,
                    column: 1
                },
                end: {
                    line: 176,
                    column: 29
                }
            },
            "66": {
                start: {
                    line: 172,
                    column: 2
                },
                end: {
                    line: 175,
                    column: 3
                }
            },
            "67": {
                start: {
                    line: 173,
                    column: 3
                },
                end: {
                    line: 173,
                    column: 45
                }
            },
            "68": {
                start: {
                    line: 174,
                    column: 3
                },
                end: {
                    line: 174,
                    column: 44
                }
            },
            "69": {
                start: {
                    line: 178,
                    column: 1
                },
                end: {
                    line: 189,
                    column: 40
                }
            },
            "70": {
                start: {
                    line: 179,
                    column: 2
                },
                end: {
                    line: 188,
                    column: 3
                }
            },
            "71": {
                start: {
                    line: 183,
                    column: 3
                },
                end: {
                    line: 183,
                    column: 30
                }
            },
            "72": {
                start: {
                    line: 185,
                    column: 3
                },
                end: {
                    line: 187,
                    column: 6
                }
            },
            "73": {
                start: {
                    line: 191,
                    column: 1
                },
                end: {
                    line: 222,
                    column: 59
                }
            },
            "74": {
                start: {
                    line: 192,
                    column: 15
                },
                end: {
                    line: 192,
                    column: 33
                }
            },
            "75": {
                start: {
                    line: 194,
                    column: 2
                },
                end: {
                    line: 221,
                    column: 3
                }
            },
            "76": {
                start: {
                    line: 195,
                    column: 28
                },
                end: {
                    line: 197,
                    column: 25
                }
            },
            "77": {
                start: {
                    line: 198,
                    column: 31
                },
                end: {
                    line: 202,
                    column: 5
                }
            },
            "78": {
                start: {
                    line: 199,
                    column: 21
                },
                end: {
                    line: 199,
                    column: 33
                }
            },
            "79": {
                start: {
                    line: 201,
                    column: 4
                },
                end: {
                    line: 201,
                    column: 37
                }
            },
            "80": {
                start: {
                    line: 204,
                    column: 3
                },
                end: {
                    line: 217,
                    column: 4
                }
            },
            "81": {
                start: {
                    line: 205,
                    column: 4
                },
                end: {
                    line: 205,
                    column: 49
                }
            },
            "82": {
                start: {
                    line: 207,
                    column: 32
                },
                end: {
                    line: 213,
                    column: 5
                }
            },
            "83": {
                start: {
                    line: 209,
                    column: 6
                },
                end: {
                    line: 211,
                    column: 12
                }
            },
            "84": {
                start: {
                    line: 214,
                    column: 30
                },
                end: {
                    line: 214,
                    column: 52
                }
            },
            "85": {
                start: {
                    line: 216,
                    column: 4
                },
                end: {
                    line: 216,
                    column: 47
                }
            },
            "86": {
                start: {
                    line: 219,
                    column: 3
                },
                end: {
                    line: 219,
                    column: 41
                }
            },
            "87": {
                start: {
                    line: 220,
                    column: 3
                },
                end: {
                    line: 220,
                    column: 41
                }
            },
            "88": {
                start: {
                    line: 224,
                    column: 1
                },
                end: {
                    line: 233,
                    column: 24
                }
            },
            "89": {
                start: {
                    line: 225,
                    column: 2
                },
                end: {
                    line: 232,
                    column: 3
                }
            },
            "90": {
                start: {
                    line: 226,
                    column: 3
                },
                end: {
                    line: 226,
                    column: 53
                }
            },
            "91": {
                start: {
                    line: 231,
                    column: 3
                },
                end: {
                    line: 231,
                    column: 53
                }
            },
            "92": {
                start: {
                    line: 231,
                    column: 20
                },
                end: {
                    line: 231,
                    column: 47
                }
            },
            "93": {
                start: {
                    line: 236,
                    column: 1
                },
                end: {
                    line: 241,
                    column: 16
                }
            },
            "94": {
                start: {
                    line: 237,
                    column: 2
                },
                end: {
                    line: 240,
                    column: 3
                }
            },
            "95": {
                start: {
                    line: 238,
                    column: 3
                },
                end: {
                    line: 238,
                    column: 53
                }
            },
            "96": {
                start: {
                    line: 239,
                    column: 3
                },
                end: {
                    line: 239,
                    column: 53
                }
            },
            "97": {
                start: {
                    line: 243,
                    column: 1
                },
                end: {
                    line: 250,
                    column: 34
                }
            },
            "98": {
                start: {
                    line: 244,
                    column: 2
                },
                end: {
                    line: 249,
                    column: 3
                }
            },
            "99": {
                start: {
                    line: 245,
                    column: 20
                },
                end: {
                    line: 245,
                    column: 32
                }
            },
            "100": {
                start: {
                    line: 246,
                    column: 21
                },
                end: {
                    line: 246,
                    column: 39
                }
            },
            "101": {
                start: {
                    line: 248,
                    column: 3
                },
                end: {
                    line: 248,
                    column: 35
                }
            },
            "102": {
                start: {
                    line: 252,
                    column: 1
                },
                end: {
                    line: 256,
                    column: 20
                }
            },
            "103": {
                start: {
                    line: 253,
                    column: 2
                },
                end: {
                    line: 255,
                    column: 3
                }
            },
            "104": {
                start: {
                    line: 254,
                    column: 3
                },
                end: {
                    line: 254,
                    column: 12
                }
            },
            "105": {
                start: {
                    line: 258,
                    column: 1
                },
                end: {
                    line: 260,
                    column: 13
                }
            },
            "106": {
                start: {
                    line: 259,
                    column: 2
                },
                end: {
                    line: 259,
                    column: 28
                }
            },
            "107": {
                start: {
                    line: 262,
                    column: 1
                },
                end: {
                    line: 272,
                    column: 2
                }
            },
            "108": {
                start: {
                    line: 267,
                    column: 2
                },
                end: {
                    line: 271,
                    column: 4
                }
            },
            "109": {
                start: {
                    line: 274,
                    column: 1
                },
                end: {
                    line: 346,
                    column: 2
                }
            },
            "110": {
                start: {
                    line: 275,
                    column: 2
                },
                end: {
                    line: 345,
                    column: 4
                }
            },
            "111": {
                start: {
                    line: 348,
                    column: 1
                },
                end: {
                    line: 350,
                    column: 2
                }
            },
            "112": {
                start: {
                    line: 349,
                    column: 2
                },
                end: {
                    line: 349,
                    column: 39
                }
            },
            "113": {
                start: {
                    line: 352,
                    column: 1
                },
                end: {
                    line: 352,
                    column: 13
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 52,
                        column: 41
                    },
                    end: {
                        line: 52,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 47
                    },
                    end: {
                        line: 52,
                        column: 71
                    }
                },
                line: 52
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 53,
                        column: 37
                    },
                    end: {
                        line: 53,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 43
                    },
                    end: {
                        line: 53,
                        column: 63
                    }
                },
                line: 53
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 54,
                        column: 41
                    },
                    end: {
                        line: 54,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 54,
                        column: 47
                    },
                    end: {
                        line: 54,
                        column: 71
                    }
                },
                line: 54
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 55,
                        column: 35
                    },
                    end: {
                        line: 55,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 55,
                        column: 41
                    },
                    end: {
                        line: 55,
                        column: 59
                    }
                },
                line: 55
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 56,
                        column: 38
                    },
                    end: {
                        line: 56,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 56,
                        column: 44
                    },
                    end: {
                        line: 56,
                        column: 65
                    }
                },
                line: 56
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 57,
                        column: 39
                    },
                    end: {
                        line: 57,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 45
                    },
                    end: {
                        line: 57,
                        column: 67
                    }
                },
                line: 57
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 58,
                        column: 32
                    },
                    end: {
                        line: 58,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 38
                    },
                    end: {
                        line: 58,
                        column: 53
                    }
                },
                line: 58
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 60,
                        column: 1
                    },
                    end: {
                        line: 60,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 7
                    },
                    end: {
                        line: 60,
                        column: 37
                    }
                },
                line: 60
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 62,
                        column: 33
                    },
                    end: {
                        line: 62,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 62,
                        column: 39
                    },
                    end: {
                        line: 62,
                        column: 55
                    }
                },
                line: 62
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 63,
                        column: 37
                    },
                    end: {
                        line: 63,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 63,
                        column: 43
                    },
                    end: {
                        line: 63,
                        column: 63
                    }
                },
                line: 63
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 65,
                        column: 1
                    },
                    end: {
                        line: 65,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 65,
                        column: 7
                    },
                    end: {
                        line: 65,
                        column: 35
                    }
                },
                line: 65
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 73,
                        column: 22
                    },
                    end: {
                        line: 73,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 73,
                        column: 28
                    },
                    end: {
                        line: 353,
                        column: 1
                    }
                },
                line: 73
            },
            "12": {
                name: "(anonymous_12)",
                decl: {
                    start: {
                        line: 150,
                        column: 16
                    },
                    end: {
                        line: 150,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 150,
                        column: 22
                    },
                    end: {
                        line: 161,
                        column: 2
                    }
                },
                line: 150
            },
            "13": {
                name: "(anonymous_13)",
                decl: {
                    start: {
                        line: 163,
                        column: 17
                    },
                    end: {
                        line: 163,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 163,
                        column: 23
                    },
                    end: {
                        line: 169,
                        column: 2
                    }
                },
                line: 163
            },
            "14": {
                name: "(anonymous_14)",
                decl: {
                    start: {
                        line: 171,
                        column: 17
                    },
                    end: {
                        line: 171,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 171,
                        column: 23
                    },
                    end: {
                        line: 176,
                        column: 2
                    }
                },
                line: 171
            },
            "15": {
                name: "(anonymous_15)",
                decl: {
                    start: {
                        line: 178,
                        column: 17
                    },
                    end: {
                        line: 178,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 178,
                        column: 23
                    },
                    end: {
                        line: 189,
                        column: 2
                    }
                },
                line: 178
            },
            "16": {
                name: "(anonymous_16)",
                decl: {
                    start: {
                        line: 191,
                        column: 17
                    },
                    end: {
                        line: 191,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 191,
                        column: 23
                    },
                    end: {
                        line: 222,
                        column: 2
                    }
                },
                line: 191
            },
            "17": {
                name: "(anonymous_17)",
                decl: {
                    start: {
                        line: 198,
                        column: 41
                    },
                    end: {
                        line: 198,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 198,
                        column: 59
                    },
                    end: {
                        line: 202,
                        column: 4
                    }
                },
                line: 198
            },
            "18": {
                name: "(anonymous_18)",
                decl: {
                    start: {
                        line: 208,
                        column: 5
                    },
                    end: {
                        line: 208,
                        column: 6
                    }
                },
                loc: {
                    start: {
                        line: 208,
                        column: 48
                    },
                    end: {
                        line: 212,
                        column: 6
                    }
                },
                line: 208
            },
            "19": {
                name: "(anonymous_19)",
                decl: {
                    start: {
                        line: 224,
                        column: 17
                    },
                    end: {
                        line: 224,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 224,
                        column: 23
                    },
                    end: {
                        line: 233,
                        column: 2
                    }
                },
                line: 224
            },
            "20": {
                name: "(anonymous_20)",
                decl: {
                    start: {
                        line: 231,
                        column: 14
                    },
                    end: {
                        line: 231,
                        column: 15
                    }
                },
                loc: {
                    start: {
                        line: 231,
                        column: 20
                    },
                    end: {
                        line: 231,
                        column: 47
                    }
                },
                line: 231
            },
            "21": {
                name: "(anonymous_21)",
                decl: {
                    start: {
                        line: 236,
                        column: 17
                    },
                    end: {
                        line: 236,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 236,
                        column: 23
                    },
                    end: {
                        line: 241,
                        column: 2
                    }
                },
                line: 236
            },
            "22": {
                name: "(anonymous_22)",
                decl: {
                    start: {
                        line: 243,
                        column: 17
                    },
                    end: {
                        line: 243,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 243,
                        column: 23
                    },
                    end: {
                        line: 250,
                        column: 2
                    }
                },
                line: 243
            },
            "23": {
                name: "(anonymous_23)",
                decl: {
                    start: {
                        line: 252,
                        column: 17
                    },
                    end: {
                        line: 252,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 252,
                        column: 23
                    },
                    end: {
                        line: 256,
                        column: 2
                    }
                },
                line: 252
            },
            "24": {
                name: "(anonymous_24)",
                decl: {
                    start: {
                        line: 258,
                        column: 17
                    },
                    end: {
                        line: 258,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 258,
                        column: 23
                    },
                    end: {
                        line: 260,
                        column: 2
                    }
                },
                line: 258
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 86,
                        column: 2
                    },
                    end: {
                        line: 86,
                        column: 23
                    }
                },
                type: "default-arg",
                locations: [{
                        start: {
                            line: 86,
                            column: 13
                        },
                        end: {
                            line: 86,
                            column: 23
                        }
                    }],
                line: 86
            },
            "1": {
                loc: {
                    start: {
                        line: 151,
                        column: 2
                    },
                    end: {
                        line: 160,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 151,
                            column: 2
                        },
                        end: {
                            line: 160,
                            column: 3
                        }
                    }, {
                        start: {
                            line: 153,
                            column: 9
                        },
                        end: {
                            line: 160,
                            column: 3
                        }
                    }],
                line: 151
            },
            "2": {
                loc: {
                    start: {
                        line: 164,
                        column: 2
                    },
                    end: {
                        line: 166,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 164,
                            column: 2
                        },
                        end: {
                            line: 166,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 164
            },
            "3": {
                loc: {
                    start: {
                        line: 172,
                        column: 2
                    },
                    end: {
                        line: 175,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 172,
                            column: 2
                        },
                        end: {
                            line: 175,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 172
            },
            "4": {
                loc: {
                    start: {
                        line: 172,
                        column: 6
                    },
                    end: {
                        line: 172,
                        column: 70
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 172,
                            column: 6
                        },
                        end: {
                            line: 172,
                            column: 11
                        }
                    }, {
                        start: {
                            line: 172,
                            column: 15
                        },
                        end: {
                            line: 172,
                            column: 44
                        }
                    }, {
                        start: {
                            line: 172,
                            column: 48
                        },
                        end: {
                            line: 172,
                            column: 70
                        }
                    }],
                line: 172
            },
            "5": {
                loc: {
                    start: {
                        line: 179,
                        column: 2
                    },
                    end: {
                        line: 188,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 179,
                            column: 2
                        },
                        end: {
                            line: 188,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 179
            },
            "6": {
                loc: {
                    start: {
                        line: 180,
                        column: 3
                    },
                    end: {
                        line: 181,
                        column: 36
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 180,
                            column: 3
                        },
                        end: {
                            line: 180,
                            column: 43
                        }
                    }, {
                        start: {
                            line: 181,
                            column: 3
                        },
                        end: {
                            line: 181,
                            column: 36
                        }
                    }],
                line: 180
            },
            "7": {
                loc: {
                    start: {
                        line: 194,
                        column: 2
                    },
                    end: {
                        line: 221,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 194,
                            column: 2
                        },
                        end: {
                            line: 221,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 194
            },
            "8": {
                loc: {
                    start: {
                        line: 194,
                        column: 6
                    },
                    end: {
                        line: 194,
                        column: 65
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 194,
                            column: 6
                        },
                        end: {
                            line: 194,
                            column: 21
                        }
                    }, {
                        start: {
                            line: 194,
                            column: 25
                        },
                        end: {
                            line: 194,
                            column: 38
                        }
                    }, {
                        start: {
                            line: 194,
                            column: 42
                        },
                        end: {
                            line: 194,
                            column: 65
                        }
                    }],
                line: 194
            },
            "9": {
                loc: {
                    start: {
                        line: 195,
                        column: 28
                    },
                    end: {
                        line: 197,
                        column: 25
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 196,
                            column: 6
                        },
                        end: {
                            line: 196,
                            column: 37
                        }
                    }, {
                        start: {
                            line: 197,
                            column: 6
                        },
                        end: {
                            line: 197,
                            column: 25
                        }
                    }],
                line: 195
            },
            "10": {
                loc: {
                    start: {
                        line: 204,
                        column: 3
                    },
                    end: {
                        line: 217,
                        column: 4
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 204,
                            column: 3
                        },
                        end: {
                            line: 217,
                            column: 4
                        }
                    }, {
                        start: {
                            line: 206,
                            column: 10
                        },
                        end: {
                            line: 217,
                            column: 4
                        }
                    }],
                line: 204
            },
            "11": {
                loc: {
                    start: {
                        line: 209,
                        column: 13
                    },
                    end: {
                        line: 211,
                        column: 11
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 210,
                            column: 9
                        },
                        end: {
                            line: 210,
                            column: 10
                        }
                    }, {
                        start: {
                            line: 211,
                            column: 9
                        },
                        end: {
                            line: 211,
                            column: 11
                        }
                    }],
                line: 209
            },
            "12": {
                loc: {
                    start: {
                        line: 225,
                        column: 2
                    },
                    end: {
                        line: 232,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 225,
                            column: 2
                        },
                        end: {
                            line: 232,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 225
            },
            "13": {
                loc: {
                    start: {
                        line: 225,
                        column: 6
                    },
                    end: {
                        line: 225,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 225,
                            column: 6
                        },
                        end: {
                            line: 225,
                            column: 26
                        }
                    }, {
                        start: {
                            line: 225,
                            column: 30
                        },
                        end: {
                            line: 225,
                            column: 46
                        }
                    }],
                line: 225
            },
            "14": {
                loc: {
                    start: {
                        line: 237,
                        column: 2
                    },
                    end: {
                        line: 240,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 237,
                            column: 2
                        },
                        end: {
                            line: 240,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 237
            },
            "15": {
                loc: {
                    start: {
                        line: 237,
                        column: 6
                    },
                    end: {
                        line: 237,
                        column: 59
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 237,
                            column: 6
                        },
                        end: {
                            line: 237,
                            column: 22
                        }
                    }, {
                        start: {
                            line: 237,
                            column: 26
                        },
                        end: {
                            line: 237,
                            column: 59
                        }
                    }],
                line: 237
            },
            "16": {
                loc: {
                    start: {
                        line: 244,
                        column: 2
                    },
                    end: {
                        line: 249,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 244,
                            column: 2
                        },
                        end: {
                            line: 249,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 244
            },
            "17": {
                loc: {
                    start: {
                        line: 244,
                        column: 6
                    },
                    end: {
                        line: 244,
                        column: 34
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 244,
                            column: 6
                        },
                        end: {
                            line: 244,
                            column: 18
                        }
                    }, {
                        start: {
                            line: 244,
                            column: 22
                        },
                        end: {
                            line: 244,
                            column: 34
                        }
                    }],
                line: 244
            },
            "18": {
                loc: {
                    start: {
                        line: 253,
                        column: 2
                    },
                    end: {
                        line: 255,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 253,
                            column: 2
                        },
                        end: {
                            line: 255,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 253
            },
            "19": {
                loc: {
                    start: {
                        line: 253,
                        column: 6
                    },
                    end: {
                        line: 253,
                        column: 64
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 253,
                            column: 6
                        },
                        end: {
                            line: 253,
                            column: 18
                        }
                    }, {
                        start: {
                            line: 253,
                            column: 22
                        },
                        end: {
                            line: 253,
                            column: 64
                        }
                    }],
                line: 253
            },
            "20": {
                loc: {
                    start: {
                        line: 262,
                        column: 1
                    },
                    end: {
                        line: 272,
                        column: 2
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 262,
                            column: 1
                        },
                        end: {
                            line: 272,
                            column: 2
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 262
            },
            "21": {
                loc: {
                    start: {
                        line: 263,
                        column: 2
                    },
                    end: {
                        line: 265,
                        column: 24
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 263,
                            column: 2
                        },
                        end: {
                            line: 263,
                            column: 23
                        }
                    }, {
                        start: {
                            line: 264,
                            column: 2
                        },
                        end: {
                            line: 264,
                            column: 25
                        }
                    }, {
                        start: {
                            line: 265,
                            column: 2
                        },
                        end: {
                            line: 265,
                            column: 24
                        }
                    }],
                line: 263
            },
            "22": {
                loc: {
                    start: {
                        line: 274,
                        column: 1
                    },
                    end: {
                        line: 346,
                        column: 2
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 274,
                            column: 1
                        },
                        end: {
                            line: 346,
                            column: 2
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 274
            },
            "23": {
                loc: {
                    start: {
                        line: 274,
                        column: 5
                    },
                    end: {
                        line: 274,
                        column: 62
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 274,
                            column: 5
                        },
                        end: {
                            line: 274,
                            column: 29
                        }
                    }, {
                        start: {
                            line: 274,
                            column: 33
                        },
                        end: {
                            line: 274,
                            column: 45
                        }
                    }, {
                        start: {
                            line: 274,
                            column: 49
                        },
                        end: {
                            line: 274,
                            column: 62
                        }
                    }],
                line: 274
            },
            "24": {
                loc: {
                    start: {
                        line: 310,
                        column: 8
                    },
                    end: {
                        line: 315,
                        column: 8
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 310,
                            column: 8
                        },
                        end: {
                            line: 310,
                            column: 18
                        }
                    }, {
                        start: {
                            line: 311,
                            column: 8
                        },
                        end: {
                            line: 314,
                            column: 10
                        }
                    }],
                line: 310
            },
            "25": {
                loc: {
                    start: {
                        line: 348,
                        column: 1
                    },
                    end: {
                        line: 350,
                        column: 2
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 348,
                            column: 1
                        },
                        end: {
                            line: 350,
                            column: 2
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 348
            },
            "26": {
                loc: {
                    start: {
                        line: 348,
                        column: 5
                    },
                    end: {
                        line: 348,
                        column: 28
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 348,
                            column: 5
                        },
                        end: {
                            line: 348,
                            column: 11
                        }
                    }, {
                        start: {
                            line: 348,
                            column: 15
                        },
                        end: {
                            line: 348,
                            column: 28
                        }
                    }],
                line: 348
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0,
            "64": 0,
            "65": 0,
            "66": 0,
            "67": 0,
            "68": 0,
            "69": 0,
            "70": 0,
            "71": 0,
            "72": 0,
            "73": 0,
            "74": 0,
            "75": 0,
            "76": 0,
            "77": 0,
            "78": 0,
            "79": 0,
            "80": 0,
            "81": 0,
            "82": 0,
            "83": 0,
            "84": 0,
            "85": 0,
            "86": 0,
            "87": 0,
            "88": 0,
            "89": 0,
            "90": 0,
            "91": 0,
            "92": 0,
            "93": 0,
            "94": 0,
            "95": 0,
            "96": 0,
            "97": 0,
            "98": 0,
            "99": 0,
            "100": 0,
            "101": 0,
            "102": 0,
            "103": 0,
            "104": 0,
            "105": 0,
            "106": 0,
            "107": 0,
            "108": 0,
            "109": 0,
            "110": 0,
            "111": 0,
            "112": 0,
            "113": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0
        },
        b: {
            "0": [0],
            "1": [0, 0],
            "2": [0, 0],
            "3": [0, 0],
            "4": [0, 0, 0],
            "5": [0, 0],
            "6": [0, 0],
            "7": [0, 0],
            "8": [0, 0, 0],
            "9": [0, 0],
            "10": [0, 0],
            "11": [0, 0],
            "12": [0, 0],
            "13": [0, 0],
            "14": [0, 0],
            "15": [0, 0],
            "16": [0, 0],
            "17": [0, 0],
            "18": [0, 0],
            "19": [0, 0],
            "20": [0, 0],
            "21": [0, 0, 0],
            "22": [0, 0],
            "23": [0, 0, 0],
            "24": [0, 0],
            "25": [0, 0],
            "26": [0, 0]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "1edf3c733d8243b1bc416a052537ae777caab3ad"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_hai8ntsct = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_hai8ntsct();
import { bindActionCreators } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { WebAuth } from 'auth0-js';
import classnames from 'classnames';
import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Loader, Notifications } from 'vio-components';
import { ROUTES } from 'vio-constants';
import { getAuth0ClientId, getAuth0Domain, removeAuth0VaporCookie, usePrevious, useReduxState } from 'vio-libs';
import { isMapRoute } from '../../lib';
import { appDeleteAlert, requestCurrentUser, requestLocations, requestOrgNetworkInterfaces, requestOrganizations, requestRemoveServerSideCookie, requestUserSettings, resetApplication, setMobile, setOrganization, setUserRoles } from '../../redux';
import Header from '../global/Header';
import SentryComponent from '../global/Sentry';
const ActivityLogsComponent = (cov_hai8ntsct().s[0]++, React.lazy(() => {
    cov_hai8ntsct().f[0]++;
    cov_hai8ntsct().s[1]++;
    return import('./ActivityLogs');
}));
const ContactsComponent = (cov_hai8ntsct().s[2]++, React.lazy(() => {
    cov_hai8ntsct().f[1]++;
    cov_hai8ntsct().s[3]++;
    return import('./Contacts');
}));
const EdgeExchangeComponent = (cov_hai8ntsct().s[4]++, React.lazy(() => {
    cov_hai8ntsct().f[2]++;
    cov_hai8ntsct().s[5]++;
    return import('./EdgeExchange');
}));
const EventsComponent = (cov_hai8ntsct().s[6]++, React.lazy(() => {
    cov_hai8ntsct().f[3]++;
    cov_hai8ntsct().s[7]++;
    return import('./Events');
}));
const LocationsComponent = (cov_hai8ntsct().s[8]++, React.lazy(() => {
    cov_hai8ntsct().f[4]++;
    cov_hai8ntsct().s[9]++;
    return import('./Locations');
}));
const ManagementComponent = (cov_hai8ntsct().s[10]++, React.lazy(() => {
    cov_hai8ntsct().f[5]++;
    cov_hai8ntsct().s[11]++;
    return import('./Management');
}));
const MapComponent = (cov_hai8ntsct().s[12]++, React.lazy(() => {
    cov_hai8ntsct().f[6]++;
    cov_hai8ntsct().s[13]++;
    return import('./Map');
}));
const NetworkingOverviewComponent = (cov_hai8ntsct().s[14]++, React.lazy(() => {
    cov_hai8ntsct().f[7]++;
    cov_hai8ntsct().s[15]++;
    return import('./NetworkingOverview');
}));
const PortComponent = (cov_hai8ntsct().s[16]++, React.lazy(() => {
    cov_hai8ntsct().f[8]++;
    cov_hai8ntsct().s[17]++;
    return import('./Port');
}));
const SettingsComponent = (cov_hai8ntsct().s[18]++, React.lazy(() => {
    cov_hai8ntsct().f[9]++;
    cov_hai8ntsct().s[19]++;
    return import('./Settings');
}));
const UnauthorizedUserComponent = (cov_hai8ntsct().s[20]++, React.lazy(() => {
    cov_hai8ntsct().f[10]++;
    cov_hai8ntsct().s[21]++;
    return import('./UnauthorizedUser');
}));
const consumerAPI = (cov_hai8ntsct().s[22]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.consumer_api_rollout);
const edgeEvents = (cov_hai8ntsct().s[23]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.edge_events);
const useSessionCookie = (cov_hai8ntsct().s[24]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.server_side_cookies);
cov_hai8ntsct().s[25]++;
const App = () => {
    cov_hai8ntsct().f[11]++;
    const dispatch = (cov_hai8ntsct().s[26]++, useDispatch());
    const location = (cov_hai8ntsct().s[27]++, useLocation());
    const navigate = (cov_hai8ntsct().s[28]++, useNavigate());
    const [queryParams, setQueryParams] = (cov_hai8ntsct().s[29]++, useSearchParams());
    const { requestingRemoveServerSideCookie } = (cov_hai8ntsct().s[30]++, useReduxState('auth0'));
    const { allUserRoles, email, requestingCurrentUser } = (cov_hai8ntsct().s[31]++, useReduxState('user'));
    const { defaultOrganization, homePage = (cov_hai8ntsct().b[0][0]++, ROUTES.MAP), requestingUserSettings } = (cov_hai8ntsct().s[32]++, useReduxState('userSettings'));
    const { organization, organizations, requestingOrganizations } = (cov_hai8ntsct().s[33]++, useReduxState('organizations'));
    const organizationSlug = (cov_hai8ntsct().s[34]++, organization === null || organization === void 0 ? void 0 : organization.slug);
    const unauthorized = (cov_hai8ntsct().s[35]++, useReduxState('interceptorsResponse.unauthorized'));
    const activeAlerts = (cov_hai8ntsct().s[36]++, useReduxState('appAlerts.active'));
    const appDeleteAlertDispatch = (cov_hai8ntsct().s[37]++, bindActionCreators(appDeleteAlert, dispatch));
    const requestCurrentUserDispatch = (cov_hai8ntsct().s[38]++, bindActionCreators(requestCurrentUser, dispatch));
    const requestLocationsDispatch = (cov_hai8ntsct().s[39]++, bindActionCreators(requestLocations, dispatch));
    const requestOrgNetworkInterfacesDispatch = (cov_hai8ntsct().s[40]++, bindActionCreators(requestOrgNetworkInterfaces, dispatch));
    const requestOrganizationsDispatch = (cov_hai8ntsct().s[41]++, bindActionCreators(requestOrganizations, dispatch));
    const requestRemoveServerSideCookieDispatch = (cov_hai8ntsct().s[42]++, bindActionCreators(requestRemoveServerSideCookie, dispatch));
    const requestUserSettingsDispatch = (cov_hai8ntsct().s[43]++, bindActionCreators(requestUserSettings, dispatch));
    const resetApplicationDispatch = (cov_hai8ntsct().s[44]++, bindActionCreators(resetApplication, dispatch));
    const setMobileDispatch = (cov_hai8ntsct().s[45]++, bindActionCreators(setMobile, dispatch));
    const setOrganizationDispatch = (cov_hai8ntsct().s[46]++, bindActionCreators(setOrganization, dispatch));
    const setUserRolesDispatch = (cov_hai8ntsct().s[47]++, bindActionCreators(setUserRoles, dispatch));
    const { pathname } = (cov_hai8ntsct().s[48]++, location);
    const classNames = (cov_hai8ntsct().s[49]++, classnames({
        'no-scroll': isMapRoute(pathname)
    }));
    const previousRequestingCurrentUser = (cov_hai8ntsct().s[50]++, usePrevious(requestingCurrentUser));
    const previousOrganization = (cov_hai8ntsct().s[51]++, usePrevious(organization));
    const previousRequestingRemoveServerSideCookie = (cov_hai8ntsct().s[52]++, usePrevious(requestRemoveServerSideCookie));
    const previousUnauthorizedState = (cov_hai8ntsct().s[53]++, usePrevious(unauthorized));
    const webAuth = (cov_hai8ntsct().s[54]++, new WebAuth({
        clientID: getAuth0ClientId(vaporio),
        domain: getAuth0Domain(vaporio)
    }));
    cov_hai8ntsct().s[55]++;
    const logout = () => {
        cov_hai8ntsct().f[12]++;
        cov_hai8ntsct().s[56]++;
        if (useSessionCookie) {
            cov_hai8ntsct().b[1][0]++;
            cov_hai8ntsct().s[57]++;
            requestRemoveServerSideCookieDispatch(consumerAPI);
        }
        else {
            cov_hai8ntsct().b[1][1]++;
            cov_hai8ntsct().s[58]++;
            removeAuth0VaporCookie();
            cov_hai8ntsct().s[59]++;
            resetApplicationDispatch();
            cov_hai8ntsct().s[60]++;
            webAuth.logout({
                returnTo: `${window.location.origin}/auth`
            });
        }
    };
    cov_hai8ntsct().s[61]++;
    React.useEffect(() => {
        cov_hai8ntsct().f[13]++;
        cov_hai8ntsct().s[62]++;
        if (isMobile) {
            cov_hai8ntsct().b[2][0]++;
            cov_hai8ntsct().s[63]++;
            setMobileDispatch();
        }
        else {
            cov_hai8ntsct().b[2][1]++;
        }
        cov_hai8ntsct().s[64]++;
        requestCurrentUserDispatch(consumerAPI);
    }, []);
    cov_hai8ntsct().s[65]++;
    React.useEffect(() => {
        cov_hai8ntsct().f[14]++;
        cov_hai8ntsct().s[66]++;
        if ((cov_hai8ntsct().b[4][0]++, email) && (cov_hai8ntsct().b[4][1]++, previousRequestingCurrentUser) && (cov_hai8ntsct().b[4][2]++, !requestingCurrentUser)) {
            cov_hai8ntsct().b[3][0]++;
            cov_hai8ntsct().s[67]++;
            requestOrganizationsDispatch(consumerAPI);
            cov_hai8ntsct().s[68]++;
            requestUserSettingsDispatch(consumerAPI);
        }
        else {
            cov_hai8ntsct().b[3][1]++;
        }
    }, [requestingCurrentUser]);
    cov_hai8ntsct().s[69]++;
    React.useEffect(() => {
        cov_hai8ntsct().f[15]++;
        cov_hai8ntsct().s[70]++;
        if ((cov_hai8ntsct().b[6][0]++, previousRequestingRemoveServerSideCookie) && (cov_hai8ntsct().b[6][1]++, !requestingRemoveServerSideCookie)) {
            cov_hai8ntsct().b[5][0]++;
            cov_hai8ntsct().s[71]++;
            resetApplicationDispatch();
            cov_hai8ntsct().s[72]++;
            webAuth.logout({
                returnTo: `${window.location.origin}/auth`
            });
        }
        else {
            cov_hai8ntsct().b[5][1]++;
        }
    }, [requestingRemoveServerSideCookie]);
    cov_hai8ntsct().s[73]++;
    React.useEffect(() => {
        cov_hai8ntsct().f[16]++;
        const orgs = (cov_hai8ntsct().s[74]++, [...organizations]);
        cov_hai8ntsct().s[75]++;
        if ((cov_hai8ntsct().b[8][0]++, orgs.length > 0) && (cov_hai8ntsct().b[8][1]++, !organization) && (cov_hai8ntsct().b[8][2]++, !requestingUserSettings)) {
            cov_hai8ntsct().b[7][0]++;
            const organizationSlug = (cov_hai8ntsct().s[76]++, queryParams.has('organization') ? (cov_hai8ntsct().b[9][0]++, queryParams.get('organization')) : (cov_hai8ntsct().b[9][1]++, defaultOrganization));
            const initialOrganization = (cov_hai8ntsct().s[77]++, orgs.find(organization => {
                cov_hai8ntsct().f[17]++;
                const { slug } = (cov_hai8ntsct().s[78]++, organization);
                cov_hai8ntsct().s[79]++;
                return slug === organizationSlug;
            }));
            cov_hai8ntsct().s[80]++;
            if (initialOrganization) {
                cov_hai8ntsct().b[10][0]++;
                cov_hai8ntsct().s[81]++;
                setOrganizationDispatch(initialOrganization);
            }
            else {
                cov_hai8ntsct().b[10][1]++;
                const sortedOrganizations = (cov_hai8ntsct().s[82]++, orgs.sort((firstOrganization, secondOrganization) => {
                    cov_hai8ntsct().f[18]++;
                    cov_hai8ntsct().s[83]++;
                    return firstOrganization.name > secondOrganization.name ? (cov_hai8ntsct().b[11][0]++, 1) : (cov_hai8ntsct().b[11][1]++, -1);
                }));
                const firstOrganization = (cov_hai8ntsct().s[84]++, sortedOrganizations[0]);
                cov_hai8ntsct().s[85]++;
                setOrganizationDispatch(firstOrganization);
            }
            cov_hai8ntsct().s[86]++;
            requestLocationsDispatch(consumerAPI);
            cov_hai8ntsct().s[87]++;
            requestOrgNetworkInterfacesDispatch();
        }
        else {
            cov_hai8ntsct().b[7][1]++;
        }
    }, [organization, organizations, requestingUserSettings]);
    cov_hai8ntsct().s[88]++;
    React.useEffect(() => {
        cov_hai8ntsct().f[19]++;
        cov_hai8ntsct().s[89]++;
        if ((cov_hai8ntsct().b[13][0]++, previousOrganization) && (cov_hai8ntsct().b[13][1]++, organizationSlug)) {
            cov_hai8ntsct().b[12][0]++;
            cov_hai8ntsct().s[90]++;
            queryParams.set('organization', organizationSlug);
            cov_hai8ntsct().s[91]++;
            setTimeout(() => {
                cov_hai8ntsct().f[20]++;
                cov_hai8ntsct().s[92]++;
                return setQueryParams(queryParams);
            }, 50);
        }
        else {
            cov_hai8ntsct().b[12][1]++;
        }
    }, [organizationSlug]);
    cov_hai8ntsct().s[93]++;
    React.useEffect(() => {
        cov_hai8ntsct().f[21]++;
        cov_hai8ntsct().s[94]++;
        if ((cov_hai8ntsct().b[15][0]++, organizationSlug) && (cov_hai8ntsct().b[15][1]++, !(queryParams === null || queryParams === void 0 ? void 0 : queryParams.has('organization')))) {
            cov_hai8ntsct().b[14][0]++;
            cov_hai8ntsct().s[95]++;
            queryParams.set('organization', organizationSlug);
            cov_hai8ntsct().s[96]++;
            navigate(`${pathname}?${queryParams.toString()}`);
        }
        else {
            cov_hai8ntsct().b[14][1]++;
        }
    }, [location]);
    cov_hai8ntsct().s[97]++;
    React.useEffect(() => {
        cov_hai8ntsct().f[22]++;
        cov_hai8ntsct().s[98]++;
        if ((cov_hai8ntsct().b[17][0]++, allUserRoles) && (cov_hai8ntsct().b[17][1]++, organization)) {
            cov_hai8ntsct().b[16][0]++;
            const { slug } = (cov_hai8ntsct().s[99]++, organization);
            const userRoles = (cov_hai8ntsct().s[100]++, allUserRoles[slug]);
            cov_hai8ntsct().s[101]++;
            setUserRolesDispatch(userRoles);
        }
        else {
            cov_hai8ntsct().b[16][1]++;
        }
    }, [organization, allUserRoles]);
    cov_hai8ntsct().s[102]++;
    React.useEffect(() => {
        cov_hai8ntsct().f[23]++;
        cov_hai8ntsct().s[103]++;
        if ((cov_hai8ntsct().b[19][0]++, unauthorized) && (cov_hai8ntsct().b[19][1]++, unauthorized !== previousUnauthorizedState)) {
            cov_hai8ntsct().b[18][0]++;
            cov_hai8ntsct().s[104]++;
            logout();
        }
        else {
            cov_hai8ntsct().b[18][1]++;
        }
    }, [unauthorized]);
    cov_hai8ntsct().s[105]++;
    React.useEffect(() => {
        cov_hai8ntsct().f[24]++;
        cov_hai8ntsct().s[106]++;
        Sentry.setUser({
            email
        });
    }, [email]);
    cov_hai8ntsct().s[107]++;
    if ((cov_hai8ntsct().b[21][0]++, requestingCurrentUser) || (cov_hai8ntsct().b[21][1]++, requestingOrganizations) || (cov_hai8ntsct().b[21][2]++, requestingUserSettings)) {
        cov_hai8ntsct().b[20][0]++;
        cov_hai8ntsct().s[108]++;
        return React.createElement("div", {
            id: "app-container"
        }, React.createElement(Loader, null));
    }
    else {
        cov_hai8ntsct().b[20][1]++;
    }
    cov_hai8ntsct().s[109]++;
    if ((cov_hai8ntsct().b[23][0]++, organizations.length > 0) && (cov_hai8ntsct().b[23][1]++, organization) && (cov_hai8ntsct().b[23][2]++, !unauthorized)) {
        cov_hai8ntsct().b[22][0]++;
        cov_hai8ntsct().s[110]++;
        return React.createElement("div", {
            id: "app-container",
            className: classNames
        }, React.createElement(Notifications, {
            activeAlerts: activeAlerts,
            deleteAlert: appDeleteAlertDispatch
        }), React.createElement(Header, null), React.createElement(React.Suspense, {
            fallback: React.createElement(Loader, null)
        }, React.createElement(SentryComponent, null, React.createElement(Routes, null, React.createElement(Route, {
            path: `${ROUTES.LOCATIONS}/*`,
            element: React.createElement(LocationsComponent, null)
        }), React.createElement(Route, {
            path: ROUTES.MAP,
            element: React.createElement(MapComponent, null)
        }), React.createElement(Route, {
            path: ROUTES.NETWORKING,
            element: React.createElement(NetworkingOverviewComponent, null)
        }), React.createElement(Route, {
            path: `${ROUTES.KEX}/*`,
            element: React.createElement(EdgeExchangeComponent, null)
        }), React.createElement(Route, {
            path: `${ROUTES.MANAGE}/*`,
            element: React.createElement(ManagementComponent, null)
        }), (cov_hai8ntsct().b[24][0]++, edgeEvents) && (cov_hai8ntsct().b[24][1]++, React.createElement(Route, {
            path: ROUTES.EVENTS,
            element: React.createElement(EventsComponent, null)
        })), React.createElement(Route, {
            path: ROUTES.CONTACTS,
            element: React.createElement(ContactsComponent, null)
        }), React.createElement(Route, {
            path: ROUTES.PORT,
            element: React.createElement(PortComponent, null)
        }), React.createElement(Route, {
            path: ROUTES.SETTINGS,
            element: React.createElement(SettingsComponent, null)
        }), React.createElement(Route, {
            path: ROUTES.ACTIVITY_LOGS,
            element: React.createElement(ActivityLogsComponent, null)
        }), React.createElement(Route, {
            path: "*",
            element: React.createElement(Navigate, {
                replace: true,
                to: homePage
            })
        })))));
    }
    else {
        cov_hai8ntsct().b[22][1]++;
    }
    cov_hai8ntsct().s[111]++;
    if ((cov_hai8ntsct().b[26][0]++, !email) || (cov_hai8ntsct().b[26][1]++, !organization)) {
        cov_hai8ntsct().b[25][0]++;
        cov_hai8ntsct().s[112]++;
        return React.createElement(UnauthorizedUserComponent, null);
    }
    else {
        cov_hai8ntsct().b[25][1]++;
    }
    cov_hai8ntsct().s[113]++;
    return null;
};
export default App;
